<main
  id="header"
  class="py-2.5 flex items-center justify-between bg-transparent"
>
  <a routerLink="/home" class="w-20">
    <img src="/namdorang-logo.png" alt="logo" />
  </a>

  <app-login-card class="hidden md:block" />
</main>
